import React, { useEffect, useState } from "react";
import { CloseIcon } from "@fluentui/react-northstar";

export interface ClearInputIconProps {
    onClick: () => void;
    disabled?: boolean;
}

const ClearInputIcon: React.FC<ClearInputIconProps> = (props) => {
    return (
        <CloseIcon
            disabled={props.disabled}
            size="small"
            onClick={() => {
                if (props.disabled) {
                    return;
                }
                props.onClick();
            }}
            styles={{ paddingLeft: "3px", cursor: "pointer" }}
        />
    );
};

export default ClearInputIcon;
